export default __webpack_public_path__ + "static/media/more.07dbdbc7.svg";